// Allowed: letters (including accented), numbers, spaces, hyphens, underscores, apostrophes, periods
const DISPLAY_NAME_REGEX = /^[a-zA-ZÀ-ÿ0-9 '\-_.]+$/

export function validateDisplayName(value) {
  if (!value || !value.trim()) return 'Display name is required'
  if (value.trim().length < 2) return 'Must be at least 2 characters'
  if (!DISPLAY_NAME_REGEX.test(value)) return 'No special characters allowed'
  return null // null = valid
}

export function validateCallsign(value) {
  if (!value || !value.trim()) return null // callsign is optional
  if (value.trim().length < 2) return 'Must be at least 2 characters'
  if (!DISPLAY_NAME_REGEX.test(value)) return 'No special characters allowed'
  return null
}